import { useRef, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import logo from './Assets/KV-Logo.png'
import { FaBars, FaTimes } from 'react-icons/fa'
import './NavBar.css'

function NavBar() {
    const navRef = useRef()
    const [scrolled, setScrolled] = useState(false)
    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40)
        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    const showNavbar = () => {
        navRef.current.classList.toggle('responsive-nav')
    }

    const headerClass = scrolled ? 'scrolled' : 'light'

    return (
        <header className={headerClass}>
            <Link to="/" className="logo-link"><img src={logo} alt="Logo" className="Logo" /></Link>

            <nav ref={navRef} onClick={showNavbar}>
                <Link to="/" className="navLink">Home</Link>
                <Link to="/Properties" className="navLink">Properties</Link>
                <Link to="/About" className="navLink">About</Link>
                <Link to="/Contact" className="navLink">Contact</Link>
                <button className="nav-button nav-close-button">
                    <FaTimes />
                </button>
            </nav>

            <button className="nav-button" onClick={showNavbar}>
                <FaBars />
            </button>
        </header>
    )
}

export default NavBar
